import React from 'react';
import { connectPagination } from 'react-instantsearch-dom';
import cx from 'classnames';

const NB_PAGES_ON_THE_SIDES = 2;
const NB_PAGES_AROUND = 2;

export const Pagination = connectPagination(
  ({ currentRefinement, nbPages, refine, createURL }) => {
    const canGoToPrevious = currentRefinement > 1;
    const canGoToNext = currentRefinement < nbPages;

    function goToPage(page) {
      return event => {
        event.preventDefault();
        refine(page);
      };
    }

    return (
      <div className="flex justify-center text-center">
        {canGoToPrevious && (
          <div className="px-1">
            <a
              href={createURL(currentRefinement - 1)}
              onClick={goToPage(currentRefinement - 1)}
            >
              &lt;
            </a>
          </div>
        )}

        {Array(nbPages)
          .fill(null)
          .map((_, index) => index + 1) // Algolia uses 1-based pagination
          .filter(index => {
            return (
              index <= NB_PAGES_ON_THE_SIDES ||
              index > nbPages - NB_PAGES_ON_THE_SIDES ||
              (index >= currentRefinement - NB_PAGES_AROUND &&
                index <= currentRefinement + NB_PAGES_AROUND)
            );
          })
          .map((page, index, allPages) => {
            const nextPage = allPages[index + 1];

            return (
              <React.Fragment key={page}>
                <div
                  className={cx(
                    'px-1',
                    page === currentRefinement && 'text-smurfs-gold font-bold'
                  )}
                >
                  <a
                    href={createURL(page)}
                    className={cx(page === currentRefinement && 'font-bold')}
                    onClick={goToPage(page)}
                  >
                    {page}
                  </a>
                </div>
                {nextPage !== page + 1 && nextPage < nbPages && (
                  <div className="px-1">&hellip;</div>
                )}
              </React.Fragment>
            );
          })}

        {canGoToNext && (
          <div className="px-1">
            <a
              href={createURL(currentRefinement + 1)}
              onClick={goToPage(currentRefinement + 1)}
            >
              &gt;
            </a>
          </div>
        )}
      </div>
    );
  }
);
